'use strict';

const helpers = require("../common/helpers");

module.exports = class devis {
    //* Propriétés privées
    #main = document.querySelector('.devis');
    #idTypeDevisALaCarte = 4;
    #blocksToggleRequired = {
        'telephone': {
            name: 'contactType',
            id: 'contactType-telephone',
            fieldsName: 'plageHoraire',
            target: 'plagesTel'
        },
        'visio': {
            name: 'contactType',
            id: 'contactType-visio',
            fieldsName: 'plageHoraire',
            target: 'plagesVisio'
        },
        'destination': {
            name: 'choixDest',
            id: 'choixDest-oui',
            fieldsName: 'DestinationSelected',
            target: null
        },
        'passager': {
            name: 'saisiePassager',
            id: 'saisiePassager-oui',
            fieldsName: 'saisiePassager',
            target: 'saisiePassager'
        }
    };
    #UrlLoguer = '/DevisWeb/SeLoguer';
    #UrlAddPassager = '/DevisWeb/ChangeNbPassager';
    #isDebug = false; /// Remover le code lors de la publication

    constructor(config) {
        this.config = config;
        this.idForm = 'ddeDevis';
    }

    /**
     * * Description : Méthode appelé dans \www.terdav.com\Views\DevisWeb\demandeDevis\userControl\_scripts.cshtml
     */
    initialize() {

        // Appel du module stepNumber pour les blocs :
        // nombre de voyageurs, durée & nuités
        const utilities = new stepNumber(this.config);
        utilities.initialize()

        // Gestion des événements
        // Click & submit
        this.event(this);

        // Gestion choix des plages horaires
        this.eventCheckAndToggle(this.#blocksToggleRequired.telephone);
        this.eventCheckAndToggle(this.#blocksToggleRequired.visio);

        // Devis à la carte : choix de la destination
        (this.config.devisType === this.#idTypeDevisALaCarte) && this.eventCheckAndToggle(this.#blocksToggleRequired.destination);

        //ajout des passagers et Gestion civilité
        // uniquement GNG & TDV
        if (settingsApp.app != 'TCA') {
            document.querySelectorAll('[data-select="civilite-a"]').forEach(el => {
                this.toggleNomNaissance(el);
            })
            this.eventCheckAndToggle(this.#blocksToggleRequired.passager);
        }

        // Coordonnées
        let settings = {
            indicatifFixe: 'CodeIsoForMobile',
            hasFixe: false,
            msg: this.config.msg
        }
        // Appel de la promesse du module indicatif telephonique
        settingsApp.modules.moduleIndicatifTel.then(() => {
            const tel = require(`modules/indicatifTelephonique`);
            let indicatifTel = new tel(settings);
            indicatifTel.event();
        });

        // Formulaire validation
        let contactFormValidation = new Formulaire(settings);
        contactFormValidation.initialize(this.idForm);

        this.moduleValidation = contactFormValidation;
    }

    // reinitialisation du mot de passe  suite à la migration des comptes en identity
    goToResetPassword(userName, password) {

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/EspaceClient/Api/ResetPasswordDevis';

        // Ajout des champs de formulaire
        const emailField = document.createElement('input');
        emailField.type = 'hidden';
        emailField.name = 'userName';
        emailField.value = userName;
        form.appendChild(emailField);

        // Ajout et soumission du formulaire
        document.body.appendChild(form);
        form.submit();
    }

    /**
     * * Description : on récupère les values Civilite, Nom, etc. du destinataire du devis et on les pousse pour Pax 1
     *  lorsque l'utilisateur coche 'oui' dans le block 'Personne participant à ce voyage'
     */
    updateDataPax1(value) {
        let self = this,
            arr = [...document.querySelectorAll('#infosPassager select')]
        document.querySelectorAll('#infosPassager input').forEach(el => {
            if (!el.closest('.grid--nomNaissance')) {
                arr.push(el)
            }
        })
        if (value) {
            arr.forEach(el => el.required = 'required')
        } else {
            arr.forEach(el => el.removeAttribute('required'))
        }
        // mettre à jour les champs du passager 1

        let fieldsPax1 = ['Civilite', 'Nom', 'Prenom'];
        fieldsPax1.forEach((el, index) => {
            document.getElementById(`ListVoyageur_0__${el}`).value = document.getElementById(el).value;
            document.getElementById(`ListVoyageur_0__${el}`).parentElement.classList.remove('is-error');
            document.querySelector(`#ListVoyageur_0__${el}  + span`).innerText = '';

            if (index === 0 && document.getElementById(el).value == 2) {
                document.getElementById('ListVoyageur_0__NomUsage').value = document.getElementById('NomUsage').value;


                document.getElementById('ListVoyageur_0__NomUsage').parentElement.parentElement.hidden = false;
                document.querySelector(`[for="ListVoyageur_0__Nom"]`).innerText = 'Nom de naissance';
            }
        })
    }
    /**
     * * Description : gestion et affichage de champs <required>
     * <destination> : devis à la carte | téléphone et visio
     */
    eventCheckAndToggle(obj) {
        let self = this,
            name = obj.name,
            id = obj.id,
            fieldsName = obj.fieldsName,
            target = obj.target || name;

        document.getElementById(id).checked ? this._isShowAndRequired(target, fieldsName) : this._isHideAndNotRequired(target, fieldsName);

        document.querySelectorAll(`[name="${name}"]`).forEach(element => {
            element.addEventListener('click', (e) => {

                // On remove les msg d'erreur
                let typeFieldRequired = [...document.querySelectorAll(`[name="${fieldsName}"]`)][0].type,
                    parent = [...document.querySelectorAll(`[name="${fieldsName}"]`)][0].parentElement;
                if (typeFieldRequired === 'select-one') {
                    parent.classList.remove('is-error');
                    parent.querySelector('.field-validation-error').textContent = '';
                }
                e.target.checked && e.target.id === id ? self._isShowAndRequired(target, fieldsName) : self._isHideAndNotRequired(target, fieldsName);
            })
        })
        document.querySelectorAll(`[name="${fieldsName}"]`).forEach((e) => {
            e.addEventListener('change', (input) => {
                if (input.target.validity.valid) {
                    document.getElementById(`${fieldsName}ErrorMsg`).textContent = '';
                    document.getElementById(`${fieldsName}ErrorMsg`).parentElement.classList.remove('is-error')
                    if (input.target.id === 'DestinationSelected') {
                        document.getElementById(`${fieldsName}ErrorMsg`).closest('.box').classList.remove('is-error')
                    }
                }
            })
        })
    }
    /**
     * * Utilities : au check/uncheck d'un <radio> on affiche/masque un bloc avec des champs <required> ou non
     */
    _isShowAndRequired(name, fieldsName) {
        document.querySelector(`[data-target="${name}"]`).parentElement.classList.add('is-open');
        helpers.show(document.querySelector(`[data-target="${name}"]`))
        document.querySelectorAll(`[data-target="${name}"] [name="${fieldsName}"]`).forEach(element => {
            element.required = true;
        });
    }
    _isHideAndNotRequired(name, fieldsName) {
        helpers.hide(document.querySelector(`[data-target="${name}"]`))
        document.querySelectorAll(`[data-target="${name}"] [name="${fieldsName}"]`).forEach(element => {

            element.required = false;
            // On décoche les checkboxes enfants && On reset le select destination
            if (element.type === 'radio') {
                element.checked = false
            } else if (element.type === 'select-one') {
                document.getElementById(fieldsName).selectedIndex = 0; // C'est le "placeholder" qui s'affiche
            }
        });
    }
    /**
     * * description ajout des listeners click et submit
     * @param {obj} self : on récupère les propriétés de la class
     */
    event(self) {
        // Event click
        self.#main.addEventListener('click', e => {
            const {
                target
            } = e;
            if (target.dataset.btn === 'toggleChoices') {
                self._showBoxChoices(target);
            } else if (target.value === 'Fermer' || target.type === 'submit') {
                document.querySelector('.box__choices').hidden = true;
                self.#main.classList.toggle('has-block-voyageurs')
            } else if (target.dataset.event === 'slide') {
                self._slide();
            } else if (target.name === self.#blocksToggleRequired.telephone.name) {
                if (target.id === self.#blocksToggleRequired.telephone.id) {
                    target.parentElement.classList.add('is-open');
                } else {
                    document.getElementById(self.#blocksToggleRequired.telephone.id).parentElement.classList.remove('is-open')
                }
                if (target.id === self.#blocksToggleRequired.visio.id) {
                    target.parentElement.classList.add('is-open');
                } else {
                    document.getElementById(self.#blocksToggleRequired.visio.id).parentElement.classList.remove('is-open')
                }
            } else if (target.id === 'getCoordEc') {
                self.connexionEspaceClient();
            } else if (target.role === 'main') {
                document.querySelector('.box__choices').hidden = true;
                self.#main.classList.remove('has-block-voyageurs');
            } else if (target.id == 'DateDepartSelected' && !helpers.isMobile()) {
                target.showPicker()
            } else {
                if (self.#isDebug) {
                    console.log('Event click : ')
                    console.log(target)
                }
            }
        })
        self.#main.addEventListener('change', e => {
            const {
                target
            } = e;

            if (self.hasNomNaissance && target.dataset.select === 'civilite-a') {
                self.toggleNomNaissance(target);
            } else if (target.name === 'saisiePassager') {
                self.updateDataPax1(JSON.parse(target.value));
            }
        })

        document.querySelector('.box__choices').addEventListener('updateInputNumber', () => {
            self._setTotalVoyageurs();
            self.hasNomNaissance && self.addPax();
        })
        document.querySelectorAll('[type="number"]').forEach((el) => el.addEventListener('keyup', () => {
            self._setTotalVoyageurs();
        }))

        document.getElementById('DateDepartSelected').addEventListener('change', () => {
            document.getElementById('DateDepartSelected').classList.remove('has-date-now')
        })

    }
    /**
     * * description : Sur mobile, le récap est en partie masqué
     */
    _slide() {
        this.isOpen ? this.#main.style.removeProperty('--slideTranslate') : this.#main.style.setProperty('--slideTranslate', 'auto');
        return false;
    }
    /*
     * * description : le nom de jeune fille est présent ou non
     */
    get hasNomNaissance() {
        return settingsApp.app != 'TCA';
    }
    /**
     * * description : return un boolean pour savoir si le récapitulatif est ouvert (visible entièrement) ou non
     */
    get isOpen() {
        return this.#main.style.getPropertyValue('--slideTranslate') === 'auto';
    }

    get nbVoyageurs() {
        let array = document.querySelectorAll('.box__choices [type="number"]');
        let n = 0;
        array.forEach(element => {
            n += element.valueAsNumber;
        });
        return n;
    }
    /**
     *
     * @param {int} total initialisé à 0
     * @description à la fermeture du block voyageurs, on met à jour le libellé du bouton
     */
    _setTotalVoyageurs() {
        document.querySelector('[data-btn="toggleChoices"]').innerText = `${this.nbVoyageurs} voyageur${this.nbVoyageurs > 1 ? 's' : ''}`
    }

    _showBoxChoices(e) {
        e.nextElementSibling.hidden = !e.nextElementSibling.hidden;
        this.#main.classList.toggle('has-block-voyageurs');
    }

    /** On affiche ou on masque le champ nom de naissance
     *
     */
    toggleNomNaissance(el) {
        if (parseInt(el.value) === 2) {
            el.parentElement.parentElement.querySelector('.grid--nomNaissance').hidden = false;
            document.querySelector(`[for="${el.id.replace('Civilite', 'Nom')}"]`).innerText = 'Nom de naissance';
        } else {
            el.parentElement.parentElement.querySelector('.grid--nomNaissance').hidden = true;
            document.querySelector(`[for="${el.id.replace('Civilite', 'Nom')}"]`).innerText = 'Nom';
        }
    }

    /**
     * @description : en se connectant à son espace client, on remplit les coordonnées de la demande de devis
     */
    connexionEspaceClient() {
        let self = this;
        document.dispatchEvent(new CustomEvent("requestSocialGoogle"));

        // // Lors de la tentative de connexion à l'Espace client,
        // // on récupère les données dans un objet
        // let data = {
        //     Action: 1,
        //     Context: '',
        //     Email: document.getElementById('EmailConnexion').value,
        //     Password: document.getElementById('password').value,
        //     __RequestVerificationToken: document.querySelector('[name="__RequestVerificationToken"]').value
        // };

        // // Préparation de la requête
        // let tool = require('common/toolsPromise');
        // let promiseTool = new tool();
        // let formData = new URLSearchParams(data);
        // promiseTool.optionsPromise = formData;

        // promiseTool.getPromiseJson(this.#UrlLoguer)
        //     .then((reponse) => {
        //         // La requête est OK et envoie une réponse
        //         // Les champs mappés
        //         let data = ['Civilite', 'Nom', 'NomUsage', 'Prenom', 'CodePostal', 'Ville', 'Email', 'TelMobile', 'CodeIsoForMobile', 'Pays'];
        //         for (const [key, value] of Object.entries(reponse)) {
        //             if (data.includes(key)) {
        //                 if (helpers.elementExist(`[name="${key}"]`)) {
        //                     document.querySelector(`[name="${key}"]`).value = value
        //                 }
        //             }
        //         }

        //         if (reponse.IsLogged) {
        //             document.body.dataset.logged = true;
        //             document.getElementById('connexionEspaceclient').remove();
        //             document.querySelector('.connexion').parentElement.querySelectorAll('.field').forEach(element => {
        //                 element.classList.remove('is-error');
        //                 if (element.querySelector('.field-validation-error') !== null) {
        //                     element.querySelector('.field-validation-error').innerText = ''
        //                 }
        //             });

        //             self.updateDataPax1();
        //             self.toggleNomNaissance(document.getElementById('Civilite'));
        //             this.token(promiseTool);
        //             document.querySelector('.connexion').parentElement.classList.remove('is-error')
        //         } else {

        //             if (reponse.UserNameToReinitPassword != null) {
        //                 self.goToResetPassword(reponse.UserNameToReinitPassword, password);
        //             }
        //             else {
        //                 if (reponse.MessageErreurMail != null) {
        //                     document.getElementById('EmailConnexion_validationMessage').innerText = reponse.MessageErreurMail;
        //                     document.getElementById('EmailConnexion_validationMessage').parentElement.classList.add('is-error');
        //                 }
        //                 if (reponse.MessageErreurPassword != null) {
        //                     document.getElementById('password_validationMessage').innerText = reponse.MessageErreurPassword;
        //                     document.getElementById('password_validationMessage').parentElement.classList.add('is-error');
        //                 }
        //             }
        //         }
        //     })
        //     .catch((e) => {
        //         console.error(e)
        //     })
    }
    token(tool) {
        tool.getPromiseTxt('/DevisWeb/GetAntiForgeryToken')
            .then((response) => {
                document.getElementById('token').innerHTML = response;
            })
            .catch((error) => {
                console.error(error)
            })
    }

    /**
     * @description : en selectionnant un nombre de voyageur, on ajoute un bloc passager avec le nom et date de naissance à saisir
     */
    addPax() {

        // Lors de la tentative de connexion à l'Espace client,
        // on récupère les données dans un objet
        let data = {
            nbAdultes: document.getElementById('NbAdulte').value,
            nbEnfant: document.getElementById('NbEnfant').value,
            nbAdo: document.getElementById('NbAdo').value,
            nbBebe: document.getElementById('NbBebe').value,
            civilite: document.getElementById('Civilite').value,
            nom: document.getElementById('Nom').value,
            prenom: document.getElementById('Prenom').value,
            nomUsage: document.getElementById('NomUsage').value
        };

        // Préparation de la requête
        let tool = require('common/toolsPromise');
        let promiseTool = new tool();
        let formData = new URLSearchParams(data);
        promiseTool.optionsPromise = formData;

        promiseTool.getPromiseTxt(this.#UrlAddPassager)
            .then((reponse) => {
                document.getElementById('infosPassager').innerHTML = reponse;
                document.querySelectorAll('#infosPassager [data-form-select="civilite"]').forEach(el => {
                    if (el.dataset.select === 'civilite-a') {
                        this.toggleNomNaissance(el);
                    } else {
                        let inputNaissance = el.closest('.grid--coordonnees').querySelector('[placeholder="jj/mm/aaaa"]');
                        Maska.create(inputNaissance);
                        inputNaissance.reportValidity();
                        this.moduleValidation._validateInput(inputNaissance, inputNaissance.parentElement.querySelector('.field-validation-error'));
                    }
                });

                if (document.getElementById('saisiePassager-oui').checked) {
                    let arr = [...document.querySelectorAll('#infosPassager select')]
                    document.querySelectorAll('#infosPassager input').forEach(el => {
                        if (!el.closest('.grid--nomNaissance')) {
                            arr.push(el)
                        }
                    })
                    arr.forEach(el => el.required = 'required')
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }
}
